function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIPasswords(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    height: "100%",
    viewBox: "0 0 1080 1080",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlSpace: "preserve",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      strokeLinejoin: "round",
      strokeMiterlimit: 2
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.983827,0,0,0.983827,13.661,-0.284699)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M723.253,493.704C756.288,495.22 782.644,522.52 782.644,555.927L782.644,834.304C782.644,868.683 754.733,896.593 720.355,896.593L351.393,896.593C317.015,896.593 289.104,868.683 289.104,834.304L289.104,555.927C289.104,523.117 314.526,496.198 346.73,493.81L346.73,390.119C346.73,286.215 431.088,201.858 534.992,201.858C638.896,201.858 723.253,286.215 723.253,390.119L723.253,493.704ZM433.328,490.966L636.686,492.116C636.686,492.116 637.142,385.132 637.086,384.489C631.849,324.163 579.118,288.079 534.992,288.535C493.017,288.969 435.92,318.1 433.656,383.797C433.476,389.017 433.328,490.966 433.328,490.966ZM503.296,714.382L492.433,784.455C492.433,784.455 490.376,798.284 492.416,802.664C496.78,812.031 503.822,811.111 503.822,811.111L565.6,810.838C565.6,810.838 572.863,811.472 577.637,802.155C579.88,797.775 577.323,783.74 577.323,783.74L566.649,714.401C590.743,702.649 607.359,677.908 607.359,649.318C607.359,609.377 574.932,576.95 534.992,576.95C495.051,576.95 462.624,609.377 462.624,649.318C462.624,677.893 479.223,702.622 503.296,714.382Z",
    style: {
      fill: "rgb(0,152,248)"
    }
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIPasswords);
export default __webpack_public_path__ + "static/media/iPasswords.dc22815b3003cc63aa043bd2cbadfed2.svg";
export { ForwardRef as ReactComponent };